import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-0de36bd3"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "text-muted",
  style: {"font-weight":"bold"}
}
const _hoisted_2 = { class: "text-muted" }
const _hoisted_3 = { style: {"margin-left":"20px"} }
const _hoisted_4 = {
  key: 0,
  class: "indicator green tooltip"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext text-muted" }, " Tache effectuée ", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = {
  key: 1,
  class: "indicator red tooltip"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tooltiptext text-muted" }, " Tache inachevée ", -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { class: "text-muted" }
const _hoisted_11 = { style: {"width":"30px","height":"30px"} }
const _hoisted_12 = { class: "text-muted" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("tr", null, [
    _createElementVNode("td", _hoisted_1, _toDisplayString(_ctx.result.action), 1),
    _createElementVNode("td", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.result.done)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9))
      ])
    ]),
    _createElementVNode("td", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        (_ctx.result.url != null)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.displayPicture())),
              class: "image-button",
              src: "/ico/eye-blue.svg"
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("td", _hoisted_12, _toDisplayString(_ctx.employeeName), 1)
  ]))
}